import React, {useEffect, useState} from 'react';
import {isSectionQuestionHidden} from "../../../common/section-questions/sections";
import {Col, Row} from "react-bootstrap";
import {FaTrashAlt} from "react-icons/fa";
import OutletWrapper from "../outlet-components/OutletWrapper";
import Answer from "../../inputs/Answer";

function Table(props) {
    const [editing,setEditing] = useState(false)
    const [position,setPosition] = useState('top')
    const visibleQuestions =  props.section.questions.filter(question => {
        return !isSectionQuestionHidden(props.section, question)
    })
    const toggleEdit=()=>{
        setEditing(!editing)
    }
    useEffect(()=>{
        setPosition('')
    },[])
    console.log(props.back)
    return (
        <OutletWrapper back={props.back} title={props.title} onEdit={toggleEdit} editing={editing}>
            <div className={`pt-2 question-transition ${position}`}>
                {visibleQuestions.map((question, index) => {
                    return (
                        <div key={question.text+question.label} className={`transitionable delay-${index+1}`}>
                            <Answer editing={editing} floating={true} key={'section-question-' + question.label} question={question} section={props.section}/>
                        </div>
                    )
                })
                }

                {
                    editing && props.onDelete && (
                        <Row>
                            <Col className={`text-center text-sm-start`} >
                                <button onClick={props.onDelete} className="btn btn-danger my-3"> <FaTrashAlt/> Delete {props.section.defaultLabel} </button>

                            </Col>
                        </Row>
                    )
                }
            </div>
        </OutletWrapper>
    );
}

export default Table;